enum SourceAction {
    FORM_SUBMISSION = 'form_submission',
    VEHICLE_CHANGE = 'vehicle_change',
    COPY = 'copy',
    PORTAL_COPY = 'portal_copy',
}

export default SourceAction
